import { createSlice } from '@reduxjs/toolkit';

// Initial state for Before After slice
const initialState = {
    beforeAfterData: {},
};

const beforeAfterSlice = createSlice({
    name: 'beforeAfter',
    initialState,
    reducers: {
        setBeforeAfterSection: (state, action) => {
            const {  data } = action.payload;
            state.beforeAfterData = data;
        },
    },
});

export const beforeAfterActions = beforeAfterSlice.actions;
export const beforeAfterReducer = beforeAfterSlice.reducer;

export const BeforeAfterActionTypes = {
    FETCH_BEFORE_AFTER: 'beforeAfter/Fetch',
};